/*
 * Snapshot of head elements shipped in the raw HTML shell, taken once at startup before
 * React renders anything (imported first from index.js).
 *
 * The shell's <title> is deliberately attribute-free so crawlers and audit tools that grep
 * for a literal `<title>` see it; that means Seo.js cannot find it by a marker attribute
 * later, so we remember the element itself here and remove it once React has rendered the
 * page's own <title>.
 */
export const STATIC_TITLE_EL = typeof document !== 'undefined' ? document.head.querySelector('title') : null;
